import * as types from '@/redux/contains/types';
import * as status from '@/common/enum'
import * as axiosWrapper from '@/redux/contains/axios-wrapper';
import * as api from '@/common/api';
import Swal from 'sweetalert2'

const address_loading = (loading) => {
    return {
        type: types.ADDRESS_LOADING,
        loading
    }
}

const address_province_success = (listAllProvince) => {
    return {
        type: types.PROVINCE_SUCCESS,
        listAllProvince
    }
}

const address_district_success = (listAllDistrict) => {
    return {
        type: types.DISTRICT_SUCCESS,
        listAllDistrict
    }
}

const getListAddress = () => (dispatch) => {

    dispatch(address_loading(true));
    axiosWrapper.axiosWithHeaders("get", api.getListAddress, null)
        .then(response => {
            if (response.status === status.STATUS_RESPONSE_OK && response.data) {
                const {
                    data
                } = response;
                if (data.status === status.STATUS_RESPONSE_OK) {
                    // dispatch(company_options_success(data.result))
                    // console.log(data);
                    const {
                        districts,
                        provinces
                    } = data.result;

                    dispatch(address_province_success(provinces))
                    dispatch(address_district_success(districts))

                } else {
                    Swal.fire({
                        title: 'Danh sách địa chỉ',
                        text: data.message,
                        imageUrl: '/img/octopus/error.svg',
                        imageWidth: 109,
                        imageHeight: 98,
                        imageAlt: 'Error',
                        confirmButtonColor: '#76cc68',
                        showCloseButton: true
                    })
                }
            } else {
                Swal.fire({
                    title: 'Danh sách địa chỉ',
                    text: response.statusText,
                    imageUrl: '/img/octopus/error.svg',
                    imageWidth: 109,
                    imageHeight: 98,
                    imageAlt: 'Error',
                    confirmButtonColor: '#76cc68',
                    showCloseButton: true
                })
            }
        })
        .catch((err) => {
            Swal.fire({
                title: 'Danh sách địa chỉ',
                text: err.toString(),
                imageUrl: '/img/octopus/error.svg',
                imageWidth: 109,
                imageHeight: 98,
                imageAlt: 'Error',
                confirmButtonColor: '#76cc68',
                showCloseButton: true
            })
        })
        .finally(() => {
            dispatch(address_loading(false));
        })
}

export {
    getListAddress
}